import { render, staticRenderFns } from "./JSensitive.vue?vue&type=template&id=8608bb0e&scoped=true"
import script from "./JSensitive.vue?vue&type=script&lang=js"
export * from "./JSensitive.vue?vue&type=script&lang=js"
import style0 from "./JSensitive.vue?vue&type=style&index=0&id=8608bb0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8608bb0e",
  null
  
)

export default component.exports